"use client";
import { Wrap, Stack, WrapItem, GridProps } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import Card, { CardProps } from "../cardsList/card";

type Props = {
  title?: string;
  desc?: string;
  list: CardProps[];
  Width?: any;
  maxWidth?: string | number;
  spacing?: GridProps["gridGap"];
  hoverEffect?: boolean;
  hover?: Record<string, any>;
};

const WrapCards = (props: Props) => {
  const {
    title,
    desc,
    list,
    Width = {
      base: "100%",
      sm: "40vw",
      md: "26vw",
      xl: "26vw",
      "2xl": "480px",
    },
    maxWidth = "100%",
    spacing = { base: 8, sm: "5vw", md: "5vw", xl: "2vw", "2xl": 12 },
    hoverEffect = false,
    hover,
  } = props;
  const HeadingVariant = useHeadingVariant();
  return (
    <Stack gap={8}>
      {title && (
        <Heading as="h2" variant={HeadingVariant} textAlign={"center"}>
          {title}
        </Heading>
      )}
      <Balancer>
        {desc && (
          <Text variant={"label1"} color={"text.100"} textAlign={"center"}>
            {desc}
          </Text>
        )}
      </Balancer>
      <Wrap gap={spacing} justify={"center"}>
        {list.map((item, index) => (
          <WrapItem key={index} w={Width} alignItems={"stretch"} maxWidth={maxWidth}>
            <Card key={index} {...item} hoverEffect={hoverEffect} hover={hover} />
          </WrapItem>
        ))}
      </Wrap>
    </Stack>
  );
};

export default WrapCards;
